import { useEffect } from "react";

// On mount, if the URL hash matches one of this page's accordion item ids,
// open that item and scroll it into view — used so PCC search results and
// Start Here links can deep-link straight into a specific accordion entry.
export function useHashAccordion(validIds, setOpenValue) {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash || !validIds.includes(hash)) return;
    setOpenValue(hash);
    const t = setTimeout(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
